import React from 'react';

import BadgeComponent from 'shared/components/Badges/BadgeComponent';
import calendarPlusIcon from 'assets/images/icon-calendar-plus.svg';

const WebinarBadge = () => (
  <BadgeComponent
    icon={calendarPlusIcon}
    title="Webinar"
    backgroundColor="#99ACDD"
  />
);

export default WebinarBadge;
